// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cluster[data-v-5dd06d79]{margin-right:10px;margin-bottom:10px;height:60px;width:200px;border-radius:6px;cursor:pointer}.cluster .deleteButton[data-v-5dd06d79]{height:0;overflow:hidden;position:relative;top:-5px;left:5px;text-align:right}.cluster[data-v-5dd06d79]:hover{border-color:var(--el-color-primary)}.cluster:hover .deleteButton[data-v-5dd06d79]{overflow:visible}", ""]);
// Exports
module.exports = exports;
